import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import moment from 'moment-timezone'

import Button from 'components/buttons/Button'
import WeeklyPayReport from 'lists/WeeklyPayReport'

import { LoadingBox } from 'components/LoadingSpinner'

import ReportsAPI from 'api/ReportsAPI'
import LeavesAPI from 'api/LeavesAPI'


import styles from './index.css'

@withRouter
export default class PayReports extends React.Component {
  
  static propTypes = {
    fortnight : PropTypes.any.isRequired
  }

  state = {
    report : null,
    leaves: [],
  }

  constructor(props) {
    super(props)
    this.fetchReport = this.fetchReport.bind(this)
    this.fetchLeaves = this.fetchLeaves.bind(this)
    this.lock = this.lock.bind(this)
  }

  async fetchLeaves() {
    this.setState({ loading2: true })
    const {response} = await LeavesAPI.list()
    this.setState({ leaves: response })
    this.setState({ loading2: false })
  }

  async fetchReport(fortnight) {
    const formattedFortnight = moment(fortnight).format('YYYY-MM-DD')
    if (this.state.lastFortnight == formattedFortnight) return;

    this.setState({ lastFortnight: formattedFortnight })
    this.setState({ loading: true })
    const {response : report} = await ReportsAPI.getPayReport(formattedFortnight)
    /*
    ---------------------------------
      simulated weeks_by_divisions
    ---------------------------------
     let r2 = {}
    r2.id = report.id 
    r2.locked = report.locked 
    r2.weeks_by_divisions = []
    for (let i = 0; i < 3; ++i) {
      r2.weeks_by_divisions.push({
        division_id: i,
        division_name: "Division "+i,
        weeks: report.weeks
      })
    }      
    */
    this.setState({
      report
    })
    this.setState({ 
      loading: false
    })
  }

  async lock() {
    this.setState({ locking: true })
    const report = Object.assign({}, this.state.report, { locked: true })
    const {status,response} = await ReportsAPI.lockPayReport(report.id, report)
    if (status >= 200 && status < 300) {
      this.setState({ 
        report
      })
    }
    this.setState({ locking: false })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fortnight != nextProps.fortnight) {
      this.fetchReport(nextProps.fortnight)
    }
  }

  componentDidMount() {
    this.fetchLeaves()
    this.fetchReport(this.props.fortnight)
  }

  render() {
    if (this.state.loading || this.state.loading2) return <LoadingBox />
    if (!this.state.report || !Object.keys(this.state.report).length) return null
   
    return (
      <div>
        {
          (this.state.report.weeks_by_divisions || []).map((e, i) => 
            <div className={styles.Division}>
              <div className={styles.DivisionHeader}>
                <h1>Division: {e.division_name}</h1>
              </div>
              <WeeklyPayReport leaves={this.state.leaves} report={e.weeks[0]}  />
              <WeeklyPayReport leaves={this.state.leaves} report={e.weeks[1]}  />
            </div>
          )
        }
        <div className={styles.Footer}>
          {
            !this.state.report.locked &&
            <Button
              loading={this.state.locking}
              fullWidth={false}
              color='green'
              onClick={this.lock}
              >
              Save & Lock 
            </Button>
          }
          {
            this.state.report.locked &&
              <h1>Report locked</h1>
          }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Reports/Pay/index.jsx